
<template>
  <div>
    <Show />
  </div>
</template>

<script>

import Show from './Show'

export default {
  components: {
    Show
  },
  props: {
  },
  data() {
    return {
      title: '发明人'
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  activated() {
  },
  methods: {
  }
}
</script>

